class Customer.ResponseTemplateTagsFilterView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/ticket/tags_filter']
  className: 'filter-field-container tags-filter d-flex pb-2'

  initialize: ({filter, possibleTags, hiddenTags, useCustomValues = false}) ->
    @intelligentFilter = filter
    @hiddenTags = hiddenTags
    @possibleTags = possibleTags
    @useCustomValues = useCustomValues

  render: ->
    @$el.html @template
    @_addTagsView()
    @

  _addTagsView: ->
    @tagsView = new Customer.ResponseTemplateTagsView
      tagsByClientCode: @possibleTags
      hiddenTags: @hiddenTags
      intelligentTags: @intelligentFilter
      useCustomValues: @useCustomValues
    @$el.find('#tags-container').append(@tagsView.render().el)

  getIntelligentTags: ->
    @tagsView.getIntelligentTags()

  hasSelectedTags: ->
    @tagsView.hasSelectedTags()
